import { render, staticRenderFns } from "./InvisibleWall.vue?vue&type=template&id=350ca846&"
import script from "./InvisibleWall.vue?vue&type=script&lang=ts&"
export * from "./InvisibleWall.vue?vue&type=script&lang=ts&"
import style0 from "./InvisibleWall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports